import React, { useEffect, useState } from 'react'
import { Col, Modal, Row, Image, Table } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import EmptyRow from '../../components/emptyRow/EmptyRow';
import ENGModalBody from '../../components/modal/ENGModalBody';
import ENGModalHeader from '../../components/modal/ENGModalHeader';
import ModuleRow from './ModuleRow';
import icTitle from "../../assets/images/ic-edit-modal.svg";
import { GetUserListData, selectUserListData} from "../../features/rolebase/userList";
import { GetAdminListData, selectAdminListData } from '../../features/rolebase/adminList';
import Edit from "../../assets/images/ic-edit.svg";
import MultiSelectCheckbu from './BuSelect';
import MultiSelectCheckSector from './SectorSelect';
import MultiSelectCheckUser from './UserSelect';
import MultiSelectCheckAdmin from './AdminSelect';
import { GetUpdateRole } from '../../features/rolebase/updateRole';
const permisionList:any=[
    {
      id:1,
      name:"View"
    },
    {
      id:2,
      name:"Add"
    },
    {
      id:3,
      name:"Edit"
    },
    {
      id:4,
      name:"Delete"
    },
]
const UserGroupEditModal = ({roleData, ModuleList,SectorList,BusinessUnitList,UserList}
  :{ roleData:any, ModuleList:any,SectorList:any,BusinessUnitList:any,UserList:any}) => {
   //console.log(roleData?.groupPermissions)
    const dispatch = useAppDispatch();

    //const UserList = useAppSelector(selectUserListData);
    
    const AdminList = useAppSelector(selectAdminListData);
   // const BusinessUnitList = useAppSelector(selectBusinessUnitList);
    //const SectorList = useAppSelector(selectSectorList);
    //console.log(UserList,"UserList")
    const [modalShow, setModalShow] = useState(false);
    const handleClose = () => setModalShow(false);
    
    const [selectedSector, setSelectedSector]=useState([])
    const [selectedBu, setSelectedBu]=useState([])
    const [selectedUser, setSelectedUser]=useState([])
    const [selectedAdmin, setSelectedAdmin]=useState([])
    const [buId, setBuId] = useState(selectedBu);
    const [sectorId, setSectorId] = useState(selectedSector);
    const [usersId, setUsersId] = useState(selectedUser);
    const [adminEmail, setAdminEmail] = useState(selectedAdmin);
    const [groupPermissions, setgroupPermissions]=useState<any>([]);
    const [roleName, setRoleName] = useState("");
    const [userRole, setUserRole]=useState(0)
    const [roleId, setRoleId] = useState(0);
    const [userRolePersmission, setuserRolePersmission]=useState<any>()   
       const handleShow=(()=>{
            setModalShow(true)
            setRoleName(roleData.roleName)
            setRoleId(roleData.roleId)
            //setRolePermissions(item.groupPermissions) 
            setgroupPermissions(roleData?.groupPermissions)
            setSelectedSector(roleData?.sector)
            setSelectedBu(roleData?.bu)
            setSelectedAdmin(roleData?.included)
            setSelectedUser(roleData?.included)
           
            var data
            if(roleData.roleId==1){
              //alert()
              dispatch(GetAdminListData(data=1))
            }
            if(roleData.roleId==5){
              dispatch(GetAdminListData(data=2))
            }
           var tempPermission=""
            roleData.groupPermissions?.filter((rolePermission:any)=>{
                tempPermission="";
                return ModuleList?.map((modulePermit:any)=>{
                    if(rolePermission.moduleId===modulePermit.moduleId){
                       tempPermission=rolePermission?.permission;  
                       
                    }
                    return;
                })
            })
            setuserRolePersmission(tempPermission)

        })
      
        // useEffect(() => {
           
        // }, []);

        useEffect(() => {
         // console.log(BusinessUnitList,"BusinessUnitList")
            var data = {
              sectorId: SectorList?.map((x:any) => x.sectorId),
              buId: BusinessUnitList?.map((x:any) => x.sectorId),
            };
            // async function fetchBusinessUnitData() {
            //   let sample = await dispatch(GetBusinessUnitList(SectorList?.map((x:any) => x.sectorId)));
            // }
            // async function fetchSectorData() {
            //   let sample = await dispatch(GetSectorList());
            // }
            async function fetchUsersData() {
              let sample = await dispatch(GetUserListData(data));
            }
          //  fetchBusinessUnitData();
           // fetchSectorData();
            fetchUsersData(); 
            // async function fetchAdminList() {
            //   await dispatch(GetAdminListData());
            // }
            // fetchAdminList();  
            
          }, [sectorId, buId, usersId, groupPermissions,BusinessUnitList]);

    const handleSubmit=async(event:any)=>{
        event.preventDefault();
        var setBuid=buId.toString()
        var setSectorId=sectorId.toString()
        var setUserId=usersId.toString()
        var setEmailIdList=adminEmail.toString()
        var selectedUser
        if(roleId===5){
          selectedUser=setEmailIdList
        }else{
          selectedUser=setUserId
        }
        var data = {
          sector:setSectorId,
          bu:setBuid,
          included:selectedUser,
          emailIdList:selectedUser,
          groupPermissions:groupPermissions
        }
        
        var postData={
          data:data,
          roleId:roleId
        }
       await dispatch( GetUpdateRole(postData))
       // setModalShow(false)
       //console.log(postData)
       }
const handleChangeModule=async(module:any, permissions:string)=>{
   let newPermissions:any = {
     moduleId:module?.moduleId, 
     permission:permissions
   };
 //console.log(module,"newPermissionsnewPermissions")
   setUserRole(module.roleId)
   let prevModuleDetails : any[] = [...groupPermissions] 
    prevModuleDetails.push(newPermissions)  
    setgroupPermissions(prevModuleDetails);
    let i;
    let len=groupPermissions?.length;
    for(i=0; i<len;  i++ ){     
      if(groupPermissions[i]?.moduleId===module.moduleId){
       // groupPermissions.pop(i)
        setgroupPermissions([...groupPermissions, newPermissions]);
        
      }else{
        setgroupPermissions([...groupPermissions, newPermissions]);
      }
   }
  
 }
  return (
    <>
         {/* edit role modal */}
         <a onClick={() => handleShow()}>
                      <span style={styles.editstyle}>
                        <Image src={Edit} />
                      </span>
                    </a>
      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop="static"
        size="xl"
        keyboard={false}
      >
       <form onSubmit={handleSubmit}>
          <ENGModalHeader icon={icTitle} title=" Assign Role " />
          <ENGModalBody
            contents={
              <>
                <div className="bgwhite  p_all mt-2 pt-2">
                  <Row>
                    <Col sm={2}>
                      <label>Role Name</label>
                    </Col>
                    <Col sm={4}>
                      <input type="text" value={roleName} disabled />
                    </Col>
                    <Col sm={7}></Col>
                  </Row>
                  <EmptyRow />
              
                  <Table className="table table-bordered text-center table-striped">
                    <thead>
                      <tr>
                        <th>Select</th>
                        <th className="text-left">Module Name</th>
                        {permisionList?.map((item: any) => {
                            return (
                            <th key={item?.id}>{item.name}</th> 
                            );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {ModuleList?.map((item: any) => {
                        return(
                        <tr key={item.moduleId} >
                          <ModuleRow
                           module={item} 
                           rolePermissions={userRolePersmission}
                           groupPermissions={groupPermissions} 
                           roleListData={roleData.groupPermissions}
                          handleChangeModule={handleChangeModule} />
                        </tr>
                        )
                      })}
                      
                    </tbody>
                  </Table>

                  <Row>
                 
                    <Col sm={4}>
                      <label>Select Sector</label>
                      <MultiSelectCheckSector
                        optionList={SectorList}
                        setId={setSectorId}
                        selectedValue={selectedSector}
                        valueKey={'sectorId'}
                        labelKey="name"
                      />
                    </Col>
                    <Col sm={4}>
                      <label>Select Business Unit</label>
                      <MultiSelectCheckbu
                        optionList={BusinessUnitList}
                        setId={setBuId}
                        selectedValue={selectedBu}
                        valueKey="buid"
                        labelKey="name"
                      />
                    </Col>
                   
                    {roleId==1 || roleId==5?
                    <Col sm={4}>
                    <label>{roleId===1?"SSO User":"Non-SSO User"}</label>
                    <MultiSelectCheckAdmin
                        optionList={AdminList}
                        setId={setAdminEmail}
                        selectedValue={selectedAdmin}
                        valueKey={"email_id"}
                        labelKey={"email_id"}
                    />
                  </Col>: <Col sm={4}>
                      <label>Include Users</label>
                      <MultiSelectCheckUser
                        optionList={UserList}
                        setId={setUsersId}
                        selectedValue={selectedUser}
                        valueKey={"userId"}
                        labelKey={"value"}
                      />
                    </Col>}
                    
                  </Row>
                 
                  <Row className="mt-4">
                    <Col sm={10}></Col>
                    <Col sm={2}>
                      <button type="button" onClick={handleClose} style={styles.button1}>
                        {" "}
                        CANCEL{" "}
                      </button>
                      <button type="submit" style={styles.button2}>
                        {" "}
                        SAVE{" "}
                      </button>
                    </Col>
                  </Row>
                </div>
              </>
            }
          />
        </form>
      </Modal>
    </>
  )
}
const styles:any={
    button2: {
        padding: "13px 20px",
        fontFamily: "Saira",
        fontSize: "12px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        borderRadius: "0",
        backgroundColor: "#e31837",
        letterSpacing: "normal",
        border: "0px",
        color: "#fff",
        float: "right",
      },
      button1: {
        padding: "13px 15px",
        fontFamily: "Saira",
        fontSize: "12px",
        fontWeight: "500",
        fontStretch: "normal",
        fontStyle: "normal",
        borderRadius: "0",
        backgroundColor: "#ffffff",
        border: "1px solid #e31837",
        letterSpacing: "normal",
        color: "#e31837",
      },
}
export default UserGroupEditModal